export const ONLY_NUMBERS = /^[0-9]+$/;

export default
{
    ONLY_NUMBERS,
};
